module.exports = __webpack_public_path__ + "img/event.38173b92.png";